import React from "react";
import { ROLES } from "../constants";
import { Link } from "react-router-dom";

const BottomSidebar = ({ role }) => {
    if (role !== ROLES.CUSTOMER) return null;

    return (
        <div
            style={{
                background: "#fff",
                border: "1px solid #E8E8E9",
                borderRadius: 20,
                padding: 12,
                marginTop: 16,
                height: "fit-content",
            }}
        >
            <div
                style={{
                    background: "#F6F7F9",
                    borderRadius: 16,
                    padding: 12,
                }}
            >
                {/* Header */}
                <div style={{ marginBottom: 10 }}>
                    <div style={{ fontWeight: 600, display: "flex", alignItems: "center", gap: 6 }}>
                        <span style={{ width: 8, height: 8, background: "green", borderRadius: "50%" }} />
                        Quick Support
                        <span style={{ fontSize: 11, color: "green", marginLeft: 6 }}>
                            Currently Online
                        </span>
                    </div>
                </div>

                {/* Buttons */}
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <Link to='/help-center/knowledge-base'>
                        <div className="support-btn blue">📚 Knowledge Base</div>
                    </Link>
                    <Link to='/help-center/support'>
                        <div className="support-btn pink">💬 Live Chat</div>
                    </Link>
                    <Link to='/help-center/feedback'>
                        <div className="support-btn pink">👍 Feedback</div>
                    </Link>
                </div>

                {/* Contact */}
                <div style={{ marginTop: 10, fontSize: 12 }}>
                    <div style={{ color: "#e85d75" }}>📞 +1 832-916-4220</div>
                    <div style={{ color: "#999" }}>✉ info@ctrade.us</div>
                </div>
            </div>
        </div>
    );
};

export default BottomSidebar;